var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useInnerValue } from 'ziphy-web-shared/basic/hooks';
import { Input } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Dropdown, DropdownContent } from 'ziphy-web-shared/basic/lib/functional';
import { getResourceCode, useResourceSearchDropdown } from '../';
import styles from './SearchMedicationInput.module.scss';
const SearchMedicationInput = (_a) => {
    var { field, setResourceId, encounterId, resourceContext, maxWidth = 0, direction, practiceSettings } = _a, inputProps = __rest(_a, ["field", "setResourceId", "encounterId", "resourceContext", "maxWidth", "direction", "practiceSettings"]);
    const [innerValue, setInnerValue] = useInnerValue(field.value);
    const code = useMemo(() => getResourceCode(innerValue === null || innerValue === void 0 ? void 0 : innerValue.code), [innerValue]);
    const { resourceSearchDropdown: dropdown, contentMountEventName } = useResourceSearchDropdown({
        encounterId,
        resourceContext,
        practiceSettings,
        onSelectSearchResult: useCallback((searchItem) => __awaiter(void 0, void 0, void 0, function* () {
            if ('id' in searchItem) {
                setResourceId(searchItem.id);
            }
            else {
                setResourceId(null);
                handleOnChange(searchItem.fhir);
            }
        }), [setResourceId, field.onChange]),
        initialSearchString: code === null || code === void 0 ? void 0 : code.display,
    });
    function handleOnChange(value) {
        setInnerValue(value);
        field.onChange(value);
    }
    return (_jsx(Dropdown, Object.assign({ ref: dropdown.dropdownRef, renderButton: ({ fieldRef, onOpen }) => {
            var _a;
            return (_jsx(Input, Object.assign({ fieldRef: fieldRef, field: {
                    value: dropdown.searchString,
                    onChange: dropdown.setSearchString,
                    isInvalid: field.isInvalid,
                }, onFocus: onOpen, onClear: () => handleOnChange({}), unFocusComponent: code && !((_a = dropdown.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.isOpen)
                    ? () => (_jsxs("div", Object.assign({ className: styles.unFocusComponent }, { children: [code.code && (_jsxs("div", Object.assign({ className: styles.code }, { children: [code.code, code.display && _jsx(_Fragment, { children: "\u00A0\u2022\u00A0" })] }))), _jsx("div", Object.assign({ className: styles.text }, { children: code.display }))] })))
                    : undefined }, inputProps)));
        }, onOpen: () => {
            if (dropdown.totalItems)
                return;
            dropdown.reloadAsyncItems();
        }, onAfterClose: () => {
            dropdown.setSearchString((code === null || code === void 0 ? void 0 : code.display) || '');
        }, direction: direction, resizeDeps: [dropdown.totalFilteredItems], maxWidth: maxWidth }, { children: _jsx(DropdownContent, { isLoading: dropdown.isLoading, items: dropdown.filteredItems, mountEventName: contentMountEventName }) })));
};
export default observer(SearchMedicationInput);
